/* import __COLOCATED_TEMPLATE__ from './side-drawer.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();